import React from "react";
import "./styles.css";
import { Images } from "../../theme";
import { useNavigate } from "react-router-dom";

export default function ProductGridCard(props) {
  let navigate = useNavigate();

  let { daily_price, firstname, location, images, lastname, rating, title } =
    props.data;

  return (
    <div
      className="col-lg-12 mainBoxShadowNew mb-3"
      onClick={() =>
        navigate("/ProductDetail", {
          state: { item: props.data, categoryData: props.categoryData },
        })
      }
    >
      <div className="row mx-3">
        <div className="col-md-4 col-12">
          <img
            src={
              images.length
                ? `${props.imageUrl}${images[0]}`
                : Images.productImg
            }
            alt="image"
            className="imgOwnProduct"
          />
        </div>
        <div className="col-md-8 col-12">
          <span className="OwnerHeading">
            {firstname} {lastname}
          </span>
          <br />
          <span className="OwnerProduct">{title}</span>
          <p className="OwnerHeading">.</p>
          <div>
            <img
              className="locationIconNewList"
              src={Images.locationIcon}
              alt="image"
            />
            <span className="OwerlocationTextNewList">{location}</span>
            <p className="priceRentals">
              ${daily_price}
              <div className="ratingNewList">
                <img src={Images.ratingIcon} alt="image" />
                <span className="ratingOwerText">{rating ? rating : 0}</span>
              </div>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
